function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18.3853 26.2285L29.6164 13.042L27.3801 11.042L16.0953 24.2913C15.5995 24.1033 15.0618 24.0003 14.5 24.0003C12.0147 24.0003 10 26.015 10 28.5003C10 30.9856 12.0147 33.0003 14.5 33.0003C16.9853 33.0003 19 30.9856 19 28.5003C19 27.6716 18.776 26.8953 18.3853 26.2285ZM13 28.5003C13 29.3287 13.6716 30.0003 14.5 30.0003C15.3284 30.0003 16 29.3287 16 28.5003C16 27.6719 15.3284 27.0003 14.5 27.0003C13.6716 27.0003 13 27.6719 13 28.5003Z",
  fill: "currentcolor"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24.5708 26.3043L13.2742 13.041L15.5106 11.041L26.8226 24.3224C27.341 24.114 27.9071 23.9993 28.5 23.9993C30.9853 23.9993 33 26.014 33 28.4993C33 30.9846 30.9853 32.9993 28.5 32.9993C26.0147 32.9993 24 30.9846 24 28.4993C24 27.7023 24.2072 26.9536 24.5708 26.3043ZM30 28.4993C30 29.3278 29.3284 29.9993 28.5 29.9993C27.6716 29.9993 27 29.3278 27 28.4993C27 27.6709 27.6716 26.9993 28.5 26.9993C29.3284 26.9993 30 27.6709 30 28.4993Z",
  fill: "currentcolor"
});

var SvgCut = function SvgCut(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgCut, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/cut.d1b1563d.svg";
export { ForwardRef as ReactComponent };